// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "email.proto" (syntax proto3)
// tslint:disable
import { EmailService } from "./email";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service EmailService
 */
export class EmailServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = EmailService.typeName;
        this.methods = EmailService.methods;
        this.options = EmailService.options;
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendSQS
     */
    sendSQS(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendPropertyDocument
     */
    sendPropertyDocument(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendPropertyDocumentExpire
     */
    sendPropertyDocumentExpire(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
